import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductLinePageBody as ProductLinePageAssembly } from "../ProductPageBody";

export const ProductLinePageBody = (
    props: Immutable<
        Pick<
            templates.ProductLinePageTemplate,
            "page" | "reviews" | "change_root_ssr" | "root_conditional_ssr"
        >
    >,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    return (
        <ProductLinePageAssembly
            value={props.page.body.value}
            reviews={props.reviews}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
        />
    );
};
